import { DocumentUnavailablePanel } from 'features/knowledgeDocumentViewer/components/DocumentUnavailablePanel'
import { EvalQueueNavigation } from 'features/knowledgeDocumentViewer/components/metadata/EvalQueueNavigation'
import { usePageMetadataEvalSession } from 'features/knowledgeDocumentViewer/contexts/PageMetadataEvalSessionContext'
import { useCallback } from 'react'

export function EvalDocumentUnavailablePanel({
  documentId,
  siteID,
}: {
  documentId: string
  siteID: string
}) {
  const { canGoBack, canGoForward, isBusy, previous, next, runExclusive } =
    usePageMetadataEvalSession()
  const handleNext = useCallback(() => {
    void runExclusive(() => next())
  }, [runExclusive, next])
  return (
    <DocumentUnavailablePanel documentId={documentId} siteID={siteID}>
      <EvalQueueNavigation
        canGoBack={canGoBack}
        canGoForward={canGoForward}
        isBusy={isBusy}
        onPrevious={previous}
        onNext={handleNext}
      />
    </DocumentUnavailablePanel>
  )
}
